import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AppData } from "../../models/data.model";
import { PostalComponent } from "../postal/postal.component";
import { ApplicationRef, ComponentFactoryResolver, Type, ViewContainerRef } from '@angular/core';
import { StartupService } from "../../services/startup.service";
import { MetaService } from '../../services/meta.service';
import { HistoryService } from "../../services/history.service";
import { Answers } from "../../models/answers.model";
import { QaService } from "../../services/qa.service";
import { trigger, state, style, animate, transition, group, query, stagger } from '@angular/animations';


@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  animations: [
    trigger('logoAnimate', [
      state('in', style({ transform: 'translateY(0)', opacity: 1 })),
      state('out', style({ transform: 'translateY(60px)', opacity: 0 })),
      transition('out => in', [
        group([
          animate('600ms cubic-bezier(0.55, 0.055, 0.675, 0.19)', style({ opacity: 1 })),
          animate('300ms cubic-bezier(.02, .01, .47, 1)', style({ transform: 'translateY(0)' }))
        ])
      ])
    ]),
    trigger('btnAnimate', [
      state('in', style({ transform: 'translateY(0)', opacity: 1 })),
      state('out', style({ transform: 'translateY(60px)', opacity: 0 })),
      transition('out => in', [
        group([
          animate('600ms 100ms cubic-bezier(0.55, 0.055, 0.675, 0.19)', style({ opacity: 1 })),
          animate('300ms 100ms cubic-bezier(.02, .01, .47, 1)', style({ transform: 'translateY(0)' }))
        ])
      ])
    ]),
    trigger('torchAnimate', [
      state('in', style({ opacity: 1 })),

      state('out', style({ opacity: 0 })),
      transition('out => in', [
        animate('600ms 200ms cubic-bezier(0.55, 0.055, 0.675, 0.19)', style({ opacity: 1 }))
      ])
    ]),
    trigger('stepAnimate', [
      transition('out => in', [
        query('.animate-step', style({ transform: 'translateX(100%)', opacity: 0 })),
        query('.animate-step',
          stagger('300ms', [
            animate('600ms cubic-bezier(.02, .01, .47, 1)', style({ transform: 'translateX(0)', opacity: 1 }))
          ]))
      ])
    ]),
    trigger('slideOut', [
      transition('in => exit', [
        query('.slide-out', style({ transform: 'translate(0)', opacity: 1 })),
        query('.slide-out', stagger('50ms', group([
          animate('200ms cubic-bezier(0.55, 0.055, 0.675, 0.19)', style({ opacity: 0 })),
          animate('300ms cubic-bezier(.02, .01, .47, 1)', style({ transform: 'translateX(-600px)' }))
        ])))
      ])
    ])
  ]
})

export class WelcomeComponent implements OnInit, AfterViewInit {
  public state: string = 'out';
  private body: Element = document.getElementsByTagName('body')[0];

  constructor(
    public startupService: StartupService,
    public metaTagService: MetaService,
    private historyService: HistoryService,
    private router: Router,
    private qaService: QaService
  ) {
    this.qaService.updateProgress('0');
  }
  ngOnInit() {
    this.body.className += 'overflow-hide';
    setTimeout(() => this.body.classList.remove('overflow-hide'), 2000);

    this.metaTagService.setMetaTags(
      this.startupService.startupData.WelcomeScreen.DocumentPageTitle,
      this.startupService.startupData.WelcomeScreen.DocumentPageTitle,
      this.startupService.startupData.WelcomeScreen.DocumentPageKeyWords
    );
  }

  ngAfterViewInit() {
    this.state = 'in';
  }

  next() {
    this.state = 'exit';

    setTimeout(() => {
      const urlArray = this.startupService.getStepRouterLink();
      this.historyService.next(`/${urlArray[1]}/${urlArray[2]}/0`, new Answers());
      this.router.navigate(this.startupService.getStepRouterLink());
    }, 300);

  }
}



// WEBPACK FOOTER //
// ./src/app/components/welcome/welcome.component.ts